module.exports = __webpack_public_path__ + "img/20190924153929510.c28bd0f3.jpg";